export const whatsapp = {
    phoneWhatsAppWidget: "6504745424",
    whatsAppWidgetEnabled: false,
    whatsAppSharedEnabled: false,
}

export const chatraComponent = {
    visibility: false,
    id: "" //RHhF8QADXcKFFuSm7
}